<template>
  <MDBRow>
    <MDBCol lg="4" md="6" class="mb-4" v-for="(productInfo, i) in productsInfo" :key="i"
      :class="{ 'd-none': !productInfo.show }">
      <Card :data="productInfo" minHeight="container-height"
        :linkText="productInfo?.linkText ?? $t('global.buttons.discover')" v-if="productInfo.show"
        :simpleLink="productInfo.simpleLink" />
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { computed } from "vue";
import Card from "@/components/General/Card/index.vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { useI18n } from 'vue-i18n'
import { useStore } from "vuex";
const { tenantConfig } = useTenantConfig();
const { t } = useI18n()
const store = useStore();

const productsInfo = computed(() => [
  {
    name: t("productInfo.index.categories.productBrochures.title"),
    link: { name: "brochure_prices" },
    description: t(
      "productInfo.index.categories.productBrochures.description"
    ),
    image: (() => {
      try {
        return require(`@/assets/img/brochures/produktbroschuren_${(store.getters.tenantId)?.toLowerCase() || 'nl'}.png`);
      } catch (e) {
        return require('@/assets/img/brochures/produktbroschuren_fr.png');
      }
    })(),
    show: tenantConfig.value.showBrochures,
    simpleLink: false,
    linkText: t(
      "productInfo.buttons.productBrochures"
    )
  },
  {
    name: t("productInfo.index.categories.bDrive.title"),
    link: tenantConfig.value.bDriveLink,
    description: t(
      "productInfo.index.categories.bDrive.description"
    ),
    image: require("@/assets/img/ProduktabbildungenAndLogo.png"),
    show: tenantConfig.value.showBDriveProductInfo,
    simpleLink: tenantConfig.value.bDriveSimpleLink,
    linkText: t(
      "global.buttons.toBDrive"
    )
  },
]);
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
</style>
